import {
  DayBar,
  PlayList,
  Holidays,
  RecentFavorites,
  CultureCustomsSlider,
  PrayersList,
  CatechesisSlider,
  CalendarIcon,
  BookIcon,
  DayCard,
  BookOpen,
  FavoritesIcon,
} from '../components';
import { fetchRecentFavorites } from '../utilities/api'; // 
import { useState, useEffect } from 'react';
import useLiturgicalEvents from '../hooks/useLiturgicalEvents';
import { toggleFavorite, fetchDevotions, fetchCultureAndCustomsListData, fetchPrayerRitesListData, fetchCatecheticalCourses } from '../utilities/api'; // Import API function
import { mapCultureCustomsListData, mapPrayerRitesListData, mapCatecheticalCoursesListData } from '../utilities';
const holidayData = {
  count: 5,
  sectionDetails: {
    title: "Upcoming Holy Days",
    icon: <CalendarIcon className="text-gold-600" />,
    link: '#',
    linkTitle: 'View All',
  },
};
const recentData = {
  count: 5,
  sectionDetails: {
    title: "Recent Favorites",
    icon: <FavoritesIcon className="text-gold-600" />,
    link: '#',
    linkTitle: 'View All',
  },
};
function PageHome() {
  // const [prayersData, setPrayersData] = useState({ items: [] });
  const [loadingPrayers, setLoadingPrayers] = useState(true);
  const [isLoading, setIsLoading] = useState(true)
  const [loadingCulture, setLoadingCulture] = useState(true);
  const [loadingCatchesis, setLoadingCatchesis] = useState(true);
  const [devotionData, setDevotionData] = useState({ items: [] })
  const [recentFavorites, setRecentFavorites] = useState([])
  const [playlistData, setPlaylistData] = useState([])
  const [playListItems, setPlayListItems] = useState([]);
  const [loadingPlayList, setLoadingPlayList] = useState(true);

  useEffect(() => {
    const loadPlayList = async () => {
      try {
        setLoadingPlayList(true);
        const today = new Date();
        const date = today.toISOString().split("T")[0];
        const response = await fetchDevotions(2, { date });

        const sortedItems = [...response.data].sort((a, b) => {
          const aTime = a.attributes?.title?.toLowerCase().includes("morning") ? 0 : 1;
          const bTime = b.attributes?.title?.toLowerCase().includes("morning") ? 0 : 1;
          return aTime - bTime;
        });

        setPlayListItems(sortedItems);
      } catch (error) {
        console.error("Error loading devotions:", error);
      } finally {
        setLoadingPlayList(false);
      }
    };

    loadPlayList();
  }, []);

  const handleToggleFavoriteDevotion = async (id) => {
    const itemIndex = playListItems.findIndex(item => item.id === id);
    if (itemIndex === -1) return;
    const originalItem = playListItems[itemIndex];
    const currentFavorite = originalItem?.attributes?.favorite ?? false;

    try {
      // Optimistically update UI
      const updatedItems = playListItems.map(item =>
        item.id === id
          ? {
            ...item,
            attributes: {
              ...item.attributes,
              favorite: !item.attributes.favorite,
            },
          }
          : item
      );
      setPlayListItems(updatedItems);

      await toggleFavorite("devotions", id, false, currentFavorite);

      if (!currentFavorite) {
        const exists = recentFavorites.find(fav => fav.id === id);
        if (!exists) {
          setRecentFavorites(prev => [{ ...originalItem, title: originalItem.attributes?.title || "Untitled Favorite" }, ...prev.slice(0, 4)]);
        }
      } else {
        setRecentFavorites(prev => prev.filter(fav => fav.id !== id));
      }
    } catch (error) {
      console.error("Failed to update favorite:", error);

      // Revert UI
      setPlayListItems(prev =>
        prev.map(item =>
          item.id === id
            ? {
              ...item,
              attributes: {
                ...item.attributes,
                favorite: !item.attributes.favorite,
              },
            }
            : item
        )
      );
    }
  };



  const [cultureSliderData, setCultureSliderData] = useState({
    title: 'Explore Culture & Customs for Today',
    link: '#',
    items: [],
  });

  const [prayersData, setPrayersData] = useState({
    title: 'Prayer & Rites',
    icon: <BookOpen className="text-white-50" />,
    link: 'prayer-and-rites',
    linkTitle: 'View All',
    items: [],

  })

  const [catchesisSliderData, seteCatchesisSliderData] = useState({
    title: 'Catechesis',
    icon: <BookIcon className="text-white-50" />,
    link: '/learn-the-faith',
    linkTitle: 'View All',
    items: [],

  })

  useEffect(() => {
    const fetchIntialFavorites = async () => {
      const data = await fetchRecentFavorites();
      setRecentFavorites(data);
    }
    fetchIntialFavorites();
  }, [])

  const today = new Date();
  const { isDataLoading, eventData } = useLiturgicalEvents(
    today.getFullYear(),
    today.getMonth() + 1,
    today.getDate()
  );
  // Ensure skeleton stays until API data is loaded
  useEffect(() => {
    if (!isDataLoading && eventData) {
      setIsLoading(false); // Hide skeleton only when API data is fully loaded
    }
  }, [isDataLoading, eventData]);

  // Extract relevant event details
  const firstEventKey = eventData ? Object.keys(eventData)[0] : null;
  const firstEvent = firstEventKey ? eventData[firstEventKey] : null;
  const disciplines = firstEvent?.disciplines || [];

  // Ensure no flickering or static data issues
  const dayData = isDataLoading
    ? {} //Show skeleton while loading (NO STATIC DATA)
    : {
      date: firstEvent?.date
        ? new Date(firstEvent.date * 1000).toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })
        : "",
        title: firstEvent?.name
        ? firstEvent.name.replace(/\s*\/\/\s*/g, "  ")
        : "",
      tag: firstEvent?.liturgicalSeasonLcl || "",
      icon: firstEvent?.icon || "",
      label: firstEvent ? "Today" : "",
      category: "Easter",
      description: firstEvent?.eventData?.description || '',
    };

  //Fetch Prayers Data from API
  useEffect(() => {
    const loadPrayers = async () => {
      try {
        setLoadingPrayers(true);
        const response = await fetchPrayerRitesListData(0, 6);
        const responseData = response.data || [];
        const includedData = response.included || [];
        const transformedData = mapPrayerRitesListData(responseData, includedData);
        // Ensure `items` is always an array
        setPrayersData({
          title: 'Prayer & Rites',
          icon: <BookOpen className="text-white-50" />,
          link: 'prayer-and-rites',
          linkTitle: 'View All',
          items: transformedData || [],
        });
      } catch (error) {
        console.error('Error fetching prayers:', error);
      } finally {
        setLoadingPrayers(false);
      }
    };
    loadPrayers();
  }, []);

  const handleToggleFavorite = async (id) => {
    try {
      const item = prayersData.items.find(item => item.id === id);
      const currentFavorite = prayersData.items.find(item => item.id === id)?.favorite;
      //Optimistically update UI
      setPrayersData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));
      await toggleFavorite('prayer-rites', id, false, currentFavorite); // API Call in background
      if (!currentFavorite) {
        // ADD to recent favorites if newly favorited
        setRecentFavorites((prev) => {
          const exists = prev.find(fav => fav.id === id);
          if (exists) return prev; // avoid duplicate
          return [item, ...prev.slice(0, 4)]; // keep max 5
        });
      } else {
        // REMOVE from recent if unfavorited
        setRecentFavorites((prev) => prev.filter(fav => fav.id !== id));
      }
    } catch (error) {
      console.error("Failed to update favorite:", error);
      //If API call fails, revert UI
      setPrayersData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));
    }
  };
  const handleToggleFavoriteCulture = async (id) => {
    try {
      const currentFavorite = cultureSliderData.items.find(item => item.id === id)?.favorite;
      const item = cultureSliderData.items.find(item => item.id === id);
      // Optimistically update UI
      setCultureSliderData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));
      await toggleFavorite('culture-customs', id, false, currentFavorite); // API Call in background
      if (!currentFavorite) {
        setRecentFavorites((prev) => {
          const exists = prev.find(fav => fav.id === id);
          if (exists) return prev;
          return [{ ...item, title: item.title || item.name || "Untitled Favorite" }, ...prev.slice(0, 4)];
        });
      } else {
        setRecentFavorites((prev) => prev.filter(fav => fav.id !== id));
      }
    } catch (error) {
      console.error("Failed to update favorite:", error);

      // If API call fails, revert UI
      setCultureSliderData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));
    }
  };

  const handleToggleFavoriteCatchesis = async (id) => {
    try {
      const currentFavorite = catchesisSliderData.items.find(item => item.id === id)?.favorite;
      const item = catchesisSliderData.items.find(item => item.id === id);
      // Optimistically update UI
      seteCatchesisSliderData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));
      await toggleFavorite('catechetical-courses', id, true, currentFavorite); // API Call in background
      if (!currentFavorite) {
        setRecentFavorites((prev) => {
          const exists = prev.find(fav => fav.id === id);
          if (exists) return prev;
          return [{ ...item, title: item.title || item.name || "Untitled Favorite" }, ...prev.slice(0, 4)];
        });
      } else {
        setRecentFavorites((prev) => prev.filter(fav => fav.id !== id));
      }
    } catch (error) {
      console.error("Failed to update favorite:", error);
      // If API call fails, revert UI
      seteCatchesisSliderData((prevData) => ({
        ...prevData,
        items: prevData.items.map(item =>
          item.id === id ? { ...item, favorite: !item.favorite } : item
        ),
      }));
    }
  };

  useEffect(() => {
    const loadCultureData = async () => {
      try {
        setLoadingCulture(true);
        const response = await fetchCultureAndCustomsListData(0, 3);
        const responseData = response.data || [];
        const includedData = response.included || [];
        const transformedData = mapCultureCustomsListData(responseData, includedData);
        // Ensure `items` is always an array
        setCultureSliderData({
          title: 'Explore Culture & Customs for Today',
          link: 'culture-and-customs',
          items: transformedData || [], // Ensure it's always an array
        });

      } catch (error) {
        console.error('Error loading culture & customs data:', error);
      } finally {
        setLoadingCulture(false);
      }
    };
    loadCultureData();
  }, []);

  useEffect(() => {
    const loadCatchesisData = async () => {
      try {
        setLoadingCatchesis(true);
        const response = await fetchCatecheticalCourses(0, 3);
        const responseData = response.data || [];
        const includedData = response.included || [];
        const transformedData = mapCatecheticalCoursesListData(responseData, includedData);
        // Ensure `items` is always an array
        seteCatchesisSliderData(prevState => ({
          ...prevState, // Preserve existing state if needed
          title: 'Catechesis',
          icon: <BookIcon className="text-white-50" />, // JSX component
          link: '/learn-the-faith',
          linkTitle: 'View All',
          items: transformedData || [], // Ensure it's always an array
        }));
      } catch (error) {
        console.error('Error loading catchesis data:', error);
      } finally {
        setLoadingCatchesis(false);
      }
    };
    loadCatchesisData();
  }, []);
  return (
    <>
      <div className="max-w-full w-full lg:w-[60%] xl:w-[67.33%] bg-white-50">
        <div className="px-4 py-8 md:pl-6 xl:px-6">
          <DayBar {...dayData} disciplines={disciplines} isLoading={isLoading} />
          <section className="p-4 overflow-hidden rounded-lg bg-gold-50">
            <PlayList
              title="Today in Benedictus"
              items={playListItems}
              loading={loadingPlayList}
              onToggleFavorite={handleToggleFavoriteDevotion}
            />

            <PlayList
              title="Alternate meditations for Today"
              columns={2}
              dayData={dayData}
              items={playListItems}
              loading={loadingPlayList}
              onToggleFavorite={handleToggleFavoriteDevotion}
            />
            <CultureCustomsSlider data={cultureSliderData} onToggleFavorite={handleToggleFavoriteCulture} isLoading={loadingCulture} />
          </section>
          <section>
            <CatechesisSlider data={catchesisSliderData} isLoading={loadingCatchesis} onToggleFavorite={handleToggleFavoriteCatchesis} />
          </section>
          <section>
            <PrayersList
              data={prayersData}
              isLoading={loadingPrayers}
              onToggleFavorite={handleToggleFavorite} />
          </section>
        </div>
      </div>
      <div className="lg:ml-0 md:h-full max-w-full w-full lg:w-[40%] xl:w-[32.67%]">
        <div className="top-0 flex flex-col px-4 py-8 xl:px-6 bg-gold-50 md:sticky">
          <div className='upcomming-days-wrapp'>
            <Holidays data={holidayData} />
          </div>
          <div className="mt-9">
            <RecentFavorites data={{
              sectionDetails: {
                title: "Recent Favorites", icon: <FavoritesIcon className="text-gold-600" />, link: '#',
                linkTitle: 'View All',
              }
            }}
              recentFavorites={recentFavorites} />
          </div>
          {/* <DayCard data={dayData} isLoading={isLoading} /> */}
        </div>
      </div>
    </>
  );
}
export default PageHome;
